import React, { useState, useEffect, useRef, Suspense } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Footer from "./FooterNew/index";
import Banner from "../components/Banner/Banner";
import WorkSection from "./Work Section/workSection";
import AdvantageSection from "./AdvantageSection/advantage";
import MLOLicense from "./mloLicenseSection/mloLicense";
import ReadyToLeap from "./ReadyToLeap/readyToLeap";
import MinutesSection from "./Minutes Section/minutesSection";
import jsonData from "./ai-branding.json"; // Import the JSON

export default function LoanOfficerHome() {
  const { loanofficername } = useParams();
  const [dpaData, setDPAData] = useState(null);
  const [loanOfficer, setLoanOfficer] = useState(null);
  const [links, setLinks] = useState(null);
  const sectionRef = useRef(null);

  // Fetch Loan Officer Data
  useEffect(() => {
    const fetchLoanOfficerData = async () => {
      if (!loanofficername) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CDN_LOANOFFICER_JSONS}${loanofficername}.json`
        );
        setLoanOfficer(response.data.loanOfficer);
      } catch (error) {
        console.error("Error fetching loan officer data:", error);
        window.location.replace("https://www.swmc.com/equodpa/");
      }
    };

    fetchLoanOfficerData();
  }, [loanofficername]);

  // Fetch DPA JSON
  useEffect(() => {
    const fetchDpaJSON = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_JOIN_OUR_TEAM_JSON);
        setDPAData(response.data);
      } catch (error) {
        console.error("Error fetching DPA JSON data:", error);
        window.location.replace("https://www.swmc.com/join-our-team/");
      }
    };

    fetchDpaJSON();
  }, []);

  // Fetch Links (with fallback to local JSON)
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks();
    }
  }, [links]);

  // Scroll to section function
  const scrollToSection = () => {
    const navbarHeight = document.getElementById("navbar").clientHeight;
    const sectionTop = sectionRef.current.offsetTop - navbarHeight;
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth",
    });
  };

  // Check if DPA data is available
  if (!dpaData) {
    return <div>Loading...</div>; // Simple loading indicator
  }

  // Individual extraction of properties
  const bannerData = dpaData.banner;
  const assistanceData = dpaData.assistance;
  const dpahelpData = dpaData.dpahelp;
  const workData = dpaData.work;
  const faqData = dpaData.faq;
  const minutesData = dpaData.disclaimer;

  return (
    <>
      {bannerData && (
        <Banner
          bannerData={bannerData}
          loanOfficer={loanOfficer}
          fetchpriority="high"
        />
      )}
      <Suspense fallback={<div>Loading...</div>}>
        {assistanceData && (
          <AdvantageSection
            assistanceData={assistanceData}
            loanOfficer={loanOfficer}
            fetchpriority="low"
            sectionRef={sectionRef}
            scrollToSection={scrollToSection}
          />
        )}
        {dpahelpData && (
          <MLOLicense dpahelpData={dpahelpData} fetchpriority="low" />
        )}
        {workData && (
          <WorkSection
            workData={workData}
            fetchpriority="low"
            handleOnClick={scrollToSection}
          />
        )}
        {faqData && (
          <ReadyToLeap
            assistanceData={assistanceData}
            loanOfficer={loanOfficer}
            dpaData={dpaData}
            faqData={faqData}
            fetchpriority="low"
            sectionRef={sectionRef}
            scrollToSection={scrollToSection}
          />
        )}
        {minutesData && (
          <MinutesSection
            minutesData={minutesData}
            fetchpriority="low"
            handleOnClick={scrollToSection}
          />
        )}
      </Suspense>
      <Footer fetchpriority="low" links={links} />
    </>
  );
}
